import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Row, Col } from 'react-bootstrap';

import { SYMBOLOGY_TYPES, POINT_TYPES, DEFAULT } from '../../../api/Styles/Styles';
import { getColor } from '../../../api/Styles/style-operations';

import GeometryOutlineFields from '../../atoms/GeometryOutlineFields';
import GeometryPointFields from '../../atoms/GeometryPointFields';
import GeometryTypeField from '../../atoms/GeometryTypeField';
import ColorPicker from '../ColorPicker';

const SingleSymbologyFields = ({
  color,
  alpha,
  updateColor,
  symbologyType,
  geojsonGeometry,
  style,
  hasTolerance,
  updateBorderColor,
  borderAlpha,
  borderColor,
  pointType,
  changePointType,
  svgCategoryList
}) => {
  const [isDefaultChecked, handleDefaultCheck] = useState(getColor(style) === DEFAULT);
  const isMarker = pointType === POINT_TYPES.MARKER;
  if (symbologyType === SYMBOLOGY_TYPES.SINGLE) {
    return (
      <Col xs={12}>
        <GeometryTypeField geojsonGeometry={geojsonGeometry} />
        <Form.Group as={Row}>
          <Form.Label column xs={6} md={isMarker ? 4 : 6}>
            Choose Geometry Color
          </Form.Label>
          <Col xs={6} md={isMarker ? 2 : 6}>
            {!isDefaultChecked && (
              <ColorPicker color={color} alpha={alpha} updateColor={updateColor} />
            )}
          </Col>
          {isMarker && (
            <Col xs={12} md={6}>
              <Form.Check
                type="checkbox"
                name="defaultColor"
                checked={isDefaultChecked}
                label="Use Default Color"
                onChange={event => {
                  handleDefaultCheck(event.target.checked);
                  if (!event.target.checked) {
                    const rgbaColor = { rgb: { a: 0.9 }, hex: color };
                    updateColor(rgbaColor);
                  }
                }}
              />
            </Col>
          )}
        </Form.Group>
        <GeometryPointFields
          geojsonGeometry={geojsonGeometry}
          style={style}
          hasTolerance={hasTolerance}
          pointType={pointType}
          changePointType={changePointType}
          svgCategoryList={svgCategoryList}
        />
        {!isDefaultChecked && (
          <GeometryOutlineFields
            geojsonGeometry={geojsonGeometry}
            style={style}
            updateBorderColor={updateBorderColor}
            borderAlpha={borderAlpha}
            borderColor={borderColor}
          />
        )}
      </Col>
    );
  }
  return '';
};

SingleSymbologyFields.propTypes = {
  color: PropTypes.string.isRequired,
  alpha: PropTypes.number.isRequired,
  updateColor: PropTypes.func.isRequired,
  symbologyType: PropTypes.string.isRequired,
  geojsonGeometry: PropTypes.string.isRequired,
  style: PropTypes.object.isRequired,
  hasTolerance: PropTypes.bool.isRequired,
  updateBorderColor: PropTypes.func.isRequired,
  borderAlpha: PropTypes.number.isRequired,
  borderColor: PropTypes.string.isRequired,
  pointType: PropTypes.string.isRequired,
  changePointType: PropTypes.func.isRequired,
  svgCategoryList: PropTypes.array.isRequired
};

export default SingleSymbologyFields;
